module.exports = __webpack_public_path__ + "img/charter.f91c5bfc.png";